import { Drawer } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import ActionButtons from "../Components/ActionButtons";
import Button from "../Components/Button";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Budget from "./Budget";
import Levels from "./Levels";
import Needs from "./Needs";

function View({
  fields,
  onNext,
  onBack,
  categories,
  translate,
  needsLevels = 5,
  labels = {},
  categoriesConfig = {},
}) {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [budget, setBudget] = useState(
    get(fields, "budget.max")
      ? { min: get(fields, "budget.min"), max: get(fields, "budget.max") }
      : {},
  );
  const [selectedValues, setSelectedValues] = useState(
    categories.reduce((acc, category) => {
      acc[category.value] = get(fields, `needs.${category.value}`, 1);
      return acc;
    }, {}),
  );
  const [alternativeMedicineEnabled, setMedecinDouceEnabled] = useState(
    get(fields, "needs.alternativeMedicine", false),
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Layout>
      <Header
        title={
          translate?.HEADER?.TITLE ||
          "Quel niveau de protection recherchez-vous ?"
        }
        highlight={translate?.HEADER?.HIGHLIGHT || "niveau de protection"}
        subtitle={translate?.HEADER?.SUBTITLE || "Vos besoins"}
      />

      <div className="miltis-form__container">
        <Needs
          categories={categories}
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          showMedecinDouce={true}
          alternativeMedicineEnabled={alternativeMedicineEnabled}
          onMedecinDouceChange={setMedecinDouceEnabled}
          translate={translate}
          needsLevels={needsLevels}
          labels={labels}
          categoriesConfig={categoriesConfig}
        />
        <Budget
          value={budget?.max ? `${budget.min}-${budget.max}` : null}
          options={[
            {
              value: "0-50",
              label:
                translate?.BUDGET?.OPTIONS?.RANGE_0_50 || "Entre 0 et 50 €",
            },
            {
              value: "50-100",
              label:
                translate?.BUDGET?.OPTIONS?.RANGE_50_100 || "Entre 50 et 100 €",
            },
            {
              value: "100-150",
              label:
                translate?.BUDGET?.OPTIONS?.RANGE_100_150 ||
                "Entre 100 et 150 €",
            },
            {
              value: "150-200",
              label:
                translate?.BUDGET?.OPTIONS?.RANGE_150_200 ||
                "Entre 150 et 200 €",
            },
            {
              value: "200-1000",
              label:
                translate?.BUDGET?.OPTIONS?.RANGE_200_PLUS || "Plus de 200 €",
            },
          ]}
          onChange={(e) => {
            const [min, max] = e.split("-");
            setBudget({ min: parseInt(min), max: parseInt(max) });
          }}
          translate={translate}
        />
        <ActionButtons
          onBack={onBack}
          nextProps={{ disabled: !budget?.max }}
          onNext={() =>
            onNext({
              payload: {
                fields: {
                  ...fields,
                  budget,
                  needs: {
                    ...selectedValues,
                    alternativeMedicine: alternativeMedicineEnabled,
                  },
                },
              },
            })
          }
        />
        {/* <DataProtection /> */}
      </div>

      <Drawer
        placement="right"
        className="miltis__drawer right--drawer"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={isMobile ? "98%" : "50%"}
      >
        <div className="drawer__wrapper">
          <div className="drawer__wrapper--header">
            <div className="title">
              <h3>
                {translate?.DRAWER?.TITLE || "Les niveaux de remboursement"}
              </h3>
            </div>
            <p>
              {translate?.DRAWER?.DESCRIPTION ||
                "Chaque niveau correspond à des choix spécifiques concernant les professionnels de santé consultés et le niveau de remboursement souhaité. Voici une présentation des différents niveaux de besoins en santé :"}
            </p>
          </div>
          <Levels
            translate={translate}
            needsLevels={needsLevels}
            labels={labels}
          />
          <Button
            type={"default"}
            onClick={() => {
              setDrawerVisible(false);
            }}
          >
            {translate?.DRAWER?.CLOSE || "Fermer"}
          </Button>
        </div>
      </Drawer>
    </Layout>
  );
}

export default View;
